import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeTracking } from "#common/utils/tracking";
import { isProduction } from "./runtime-config";

// Initialize tracking scripts (GTM and data layer)
initializeTracking(isProduction());

createRoot(document.getElementById("root")!).render(<App />);
